// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__3EUY8","navText":"Navbar_navText__t6mTp","navLogo":"Navbar_navLogo__1wI7g","imgLogo":"Navbar_imgLogo__3HiZ3"};